var _circle, _circle2, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 74.5,
    fill: "#f28a0f",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 58.752,
    fill: "#f28a0f",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    x: 32,
    y: 33,
    fill: "#f28a0f",
    rx: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.864,
    d: "M83.546 92.182H64.454c-7.637 0-9.546-1.91-9.546-9.546V67.364c0-7.637 1.91-9.546 9.546-9.546h19.09c7.637 0 9.546 1.91 9.546 9.546v15.272c0 7.637-1.91 9.546-9.545 9.546zm-5.728-24.819h9.546M79.727 75h7.637m-3.818 7.637h3.818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.864,
    d: "M67.318 73.644a3.456 3.456 0 1 0 0-6.91 3.456 3.456 0 0 0 0 6.91M74 83.266a5.766 5.766 0 0 0-5.23-5.193 14.8 14.8 0 0 0-2.903 0c-2.768.268-4.963 2.425-5.23 5.193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.0a2624b7303b307e5a090f0906fdf684.svg";
export { ForwardRef as ReactComponent };